const getURL = () => {
  // return 'http://localhost:3004/api/'
  // return 'https://18.159.102.65:3003/api/'
  // return 'https://back.dev.elitedanza.com:3003/api/'
  // return 'https://back2.dev.elitedanza.com:3003/api/'
  // return 'https://api.farmaciasdeguardia.top:3001/api/'
  // return 'https://api.garredev.online:3003/api/'
  // return 'https://back3.aws.farm.elitedanza.com:3001/api/'
  // return 'https://back3.aws.farm.elitedanza.com/api/'
  return 'https://api.elitedanza.com/api/'
}

export default {
  getURL
}